import { createFileRoute, redirect } from '@tanstack/react-router';

import { PERMISSIONS as P, projectPermissions } from '@/app/permissions';
import { bootSession } from '@/lib/auth/session';

export const Route = createFileRoute('/_app/projects/$projectId/cost/')({
  beforeLoad: async ({ params }) => {
    // The cost picture for those who may see money; field roles get the BOQ
    // (quantities), someone who only records spending gets expenses, and a
    // buyer without either gets the scanned documents; otherwise the first cost tab
    // the person can open.
    const { me } = await bootSession();
    const granted = projectPermissions(me, params.projectId);
    const to = granted.has(P.costView)
      ? '/projects/$projectId/cost/overview'
      : granted.has(P.boqEdit) || granted.has(P.progressWrite)
        ? '/projects/$projectId/cost/boq'
        : granted.has(P.expensesWrite)
          ? '/projects/$projectId/cost/expenses'
          : granted.has(P.variationsWrite)
            ? '/projects/$projectId/cost/variations'
            : granted.has(P.materialsOnSite)
              ? '/projects/$projectId/cost/materials-on-site'
              : granted.has(P.procurementManage) && granted.has(P.mediaUpload)
                ? '/projects/$projectId/cost/scans'
                : '/projects/$projectId/cost/expenses';
    throw redirect({ to, params, replace: true });
  },
});
